import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  header: {
    id: 'pages.index.header',
    defaultMessage: '<strong>.ART</strong> affiliate program',
  },
  text: {
    id: 'pages.index.text',
    defaultMessage: 'You spread the word. We share the wealth.',
  },
  dashboard: {
    id: 'pages.index.dashboard',
    defaultMessage: 'Dashboard',
  },
  register: {
    id: 'pages.index.register',
    defaultMessage: 'Register',
  },
  partnerTitle: {
    id: 'pages.index.partnerTitle',
    defaultMessage: 'Who can become a partner',
  },
  partnerText: {
    id: 'pages.index.partnerText',
    defaultMessage: 'Anyone enthusiastic about .ART principles and goals!',
  },
  partnerText2: {
    id: 'pages.index.partnerText2',
    defaultMessage: "Up to 20% for life on all transactions generated by affiliate's link.",
  },
  partnerText3: {
    id: 'pages.index.partnerText3',
    defaultMessage: 'Withdrawals of earned money on a monthly basis.',
  },
  partnerText4: {
    id: 'pages.index.partnerText4',
    defaultMessage: 'Ability to set your affiliate links to any page.',
  },
  partnerText5: {
    id: 'pages.index.partnerText5',
    defaultMessage: 'Earn money in real time tracking referral statistics.',
  },
  partnerText6: {
    id: 'pages.index.partnerText6',
    defaultMessage: 'High-quality promotional materials to help you push traffic.',
  },
  partnerText7: {
    id: 'pages.index.partnerText7',
    defaultMessage: 'Advice on any matters convenient for you.',
  },
  partnerBenefitTitle: {
    id: 'pages.index.partnerBenefitTitle',
    defaultMessage: 'Partner Benefits',
  },
  partnerBenefitText: {
    id: 'pages.index.partnerBenefitText',
    defaultMessage: 'Here is what you will get out of it.',
  },
  partnerBenefitText2: {
    id: 'pages.index.partnerBenefitText2',
    defaultMessage: 'Various tariff plans to motivate you as we are building the .ART community together - see Rewards section.',
  },
  partnerBenefitTex3: {
    id: 'pages.index.partnerBenefitTex3',
    defaultMessage: '.ART will list you, using your logo and branding, as a.ART Affiliate on our official website with redirection to a dedicated .ART landing page on your official website. * Mention you as a .ART Affiliate in relevant PR activities and on our official social networks.',
  },
});



// WEBPACK FOOTER //
// ./src/pages/IndexPage/messages.js